const blank = {
  type: "",
  sweet: "",
  body: "",
  traits: [],
  varietals: [],
  characteristics: []
};

module.exports = blank;
